
export default {
  inserted(el, binding) {
    const defaultImg = require('@/assets/image/home/defaultImg.png')
    const errorImg = require('@/assets/image/home/defaultImg.png')
    
    el.src = defaultImg
    el.dataset.src = binding.value

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = new Image()
          img.src = el.dataset.src
          img.onload = () => {
            el.src = img.src
            observer.unobserve(el)
          }
          img.onerror = () => {
            el.src = errorImg
            observer.unobserve(el)
          }
        }
      })
    }, {
      threshold: 0.01,
      rootMargin: '0px 0px 100px 0px' // 提前100px加载
    })

    observer.observe(el)
  }
}
